import React from 'react';
import {
    Textarea
} from 'shared/components/ui/textarea';
import {
    cn
} from 'shared/lib/utils';

/**
 * LongTextField — inline multiline input for prompts, descriptions, JSON snippets, etc.
 *
 * Props:
 *   value (string)
 *   onChange (string => void)
 *   label (string, optional) — aria-label
 *   placeholder (string, optional)
 *   helpText (node, optional)
 *   monospace (bool) — defaults true (prompts, OEL, etc.)
 *   previewLines (number) — initial row count (default 3)
 *   rows (number, optional) — overrides previewLines for textarea rows
 */
export default function LongTextField({
    value, onChange, label = 'Edit text', placeholder = '', helpText = null,
    monospace = true, previewLines = 3, rows = undefined,
}) {
    const lineRows = rows ?? previewLines;

    return (
        <div>
            <Textarea
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                rows={lineRows}
                aria-label={label}
                className={cn(
                    'resize-y',
                    monospace ? 'font-mono text-[12.5px]' : 'text-sm',
                    lineRows >= 4 && 'min-h-[120px]'
                )}
            />
            {helpText && (
                <div
                    className="ds-help"
                    style={{
                        fontSize: 'var(--ds-text-xs)',
                        color: 'var(--ds-text-muted)',
                        marginTop: 6
                    }}
                >
                    {helpText}
                </div>
            )}
        </div>
    );
}
